import type { ReactElement } from 'react';

import { pomConfig } from '@/configs/pom-config';

export function TailwindIndicator(): ReactElement | null {
  if (['production', 'staging'].includes(`${pomConfig.env}`)) {
    return null;
  }
  return (
    <div className='fixed bottom-2 left-2 z-99 flex size-6 select-none items-center justify-center rounded-full bg-background p-3 font-medium font-mono text-foreground text-xs shadow-md dark:bg-primary dark:text-primary-foreground'>
      <span className='block sm:hidden'>xs</span>
      <span className='hidden sm:block md:hidden'>sm</span>
      <span className='hidden md:block lg:hidden'>md</span>
      <span className='hidden lg:block xl:hidden'>lg</span>
      <span className='hidden xl:block 2xl:hidden'>xl</span>
      <span className='hidden 2xl:block'>2xl</span>
    </div>
  );
}
